import type * as T from './src/order/pairs';
import OrderClient from './src/order/OrderClient';
export type { T };
export default OrderClient;
